import { faUserSecret } from "@fortawesome/pro-light-svg-icons";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { DO_MIMIC_USER } from "common/actions/authentication";
import { PrimaryButton } from "common/components/buttons";

import { UserSelect } from "common/components/select/userselect";

import { PanelIcon, NotificationPopup, PanelHeader, Title, FullHeightList } from "./notificationPopup";

export const MimicPopup = function({ onVisibilityChange }) {
    const popupRef = useRef();
    const mimicPickerRef = useRef();
    const dispatch = useDispatch();
    const canMimic = useSelector((state) => state.common.user_permissions.can_mimic_users);
    const hasTopbarMimicking = useSelector((state) => state.common.user.superuser);
    
    const [user, setUser] = useState();
    
    if (!canMimic || !hasTopbarMimicking) return null;
    
    return (
        <NotificationPopup
            ref={popupRef}
            icon={faUserSecret}
            iconStyle="mimic"
            title="View this page as another user"
            onVisibilityChange={onVisibilityChange}
        >
            <div>
                <PanelHeader>
                    <Title>Mimic this page</Title>
                    <PanelIcon onClick={() => popupRef.current.close()}><FontAwesomeIcon icon={faTimes} /></PanelIcon>
                </PanelHeader>
                <MimicPicker ref={mimicPickerRef}>
                    <div className="mimic-label">Select a user to mimic:</div>
                    <UserSelect onChange={setUser} width="100%" getPopupContainer={() => mimicPickerRef.current} />
                    <Row justify="end">
                        <Col>
                            <PrimaryButton disabled={!user} onClick={() => dispatch(DO_MIMIC_USER(user, window.location.href))}>Mimic</PrimaryButton>
                        </Col>
                    </Row>
                </MimicPicker>
            </div>
        </NotificationPopup>
    );
};

const MimicPicker = styled(FullHeightList)`
    padding: 10px;
    
    .mimic-label {
        margin-bottom: 10px;
        font-size: ${({ theme }) => theme.fontSizeLarge};
    }
`;
